// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/stylus/components/_switch.styl
// module id = 200
// module chunks = 0